<template>
	<div>
		<h1>Participant Timeline</h1>

		<i
			>Time schedule of enrolment, interventions (including any run-ins and
			washouts), assessments, and visits for participants. A schematic diagram
			is highly recommended</i
		>

		<!-- <InputSelectYesNo question="Did you fill out a schematic diagram?" v-model="$tera.project.schematic"
			@input="updateField('schematic', $event)" /> -->
		<InputSelectDropdown
			question="How long the trial run?"
			:options="trialTimelineOptions"
			v-model="$tera.project.TrialWizard.trialTimeline"
			@input="calculateTimeLine"
			bookmark="trial-period"
		/>

		<InputTextSingleLine
			v-if="$tera.project.TrialWizard.trialTimeline == 'other'"
			question="How long the trial run?"
			placeholder=""
			v-model="$tera.project.TrialWizard.trialTimelineOther"
			@input="calculateTimeLine"
			bookmark="trial-period"
		/>

		<InputSelectDropdown
			question="How often will the outcomes be assessed?"
			:options="trialTimeFrequencyOptions"
			v-model="$tera.project.TrialWizard.trialTimeFrequency"
			@input="calculateTimeLine"
			bookmark="trial-frequency"
		/>

		<InputTextSingleLine
			v-if="$tera.project.TrialWizard.trialTimeFrequency == 'other'"
			question="How long outcomes be assessed?"
			placeholder=""
			v-model="$tera.project.TrialWizard.trialTimeFrequencyOther"
			@input="calculateTimeLine"
			bookmark="trial-frequency"
		/>

		<InputSelectYesNo
			question="Will there be a pre-baseline assessment?"
			v-model="$tera.project.TrialWizard.ispreBaseline"
			@input="addPreBaseline"
			bookmark="pre-baseline"
		/>

		<InputPTTableCustom
			question="Participant timeline as follows (Type 'X' where outcomes won't be measured)."
			v-model="$tera.project.TrialWizard.timelineTable"
		>
		</InputPTTableCustom>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
import OutputParticipantTimeline from "./OutputParticipantTimeline.vue";
import InputPTTableCustom from "@/components/InputPTTableCustom.vue";

export default {
	components: {
		InputPTTableCustom
	},
	data() {
		return {
			outputComponent: OutputParticipantTimeline,
			trialTimelineOptions: [
				"3 months",
				"6 months",
				"12 months",
				"24 months",
				"other"
			],
			trialTimeFrequencyOptions: [
				"2 weeks",
				"1 month",
				"2 months",
				"3 months",
				"6 months",
				"12 months",
				"24 months",
				"other"
			],
			table: {
				headers: ["ID", "Name", "Age", "Email"],
				rows: [
					[1, "Alice", 30, "alice@example.com"],
					[2, "Bob", 25, "bob@example.com"],
					[3, "Charlie", 35, "charlie@example.com"],
					[4, "Diana", 28, "diana@example.com"]
				]
			}
		};
	},
	mounted() {
		this.compareAndCalculate();
	},
	methods: {
		calculate() {
			console.log("Clicked", this.$tera.project);
			const concatednames = [
				...this.$tera.project.TrialWizard.primary.map(item => item.name || ""),
				...this.$tera.project.TrialWizard.secondary.map(item => item.name || "")
				// ...this.$tera.project.adverse.map(item => item.name || "")
			];
			const names = concatednames.filter(x => x != "");
			console.log("data", names);

			const convertToNumeric = value => {
				const [num, unit] = value.split(" ");
				return { num: parseFloat(num), unit: unit };
			};

			const total = convertToNumeric(
				this.$tera.project.TrialWizard.trialTimeline === "other"
					? this.$tera.project.TrialWizard.trialTimelineOther
					: this.$tera.project.TrialWizard.trialTimeline
			);
			const interval = convertToNumeric(
				this.$tera.project.TrialWizard.trialTimeFrequency === "other"
					? this.$tera.project.TrialWizard.trialTimeFrequencyOther
					: this.$tera.project.TrialWizard.trialTimeFrequency
			);

			// Convert all time units to days
			const convertToDays = (num, unit) => {
				switch (unit) {
					case "hours":
					case "hour":
						return num / 24;
					case "days":
					case "day":
						return num;
					case "weeks":
					case "week":
						return num * 7;
					case "months":
					case "month":
						return num * 30.44;
					// return num * 30;
					case "years":
					case "year":
						return num * 365.25;
					// return num * 365;
					default:
						return num;
				}
			};

			const totalDays = convertToDays(total.num, total.unit);
			const intervalDays = convertToDays(interval.num, interval.unit);

			const headers = [{ label: "Outcomes" }];
			const seenHeaders = new Set();

			for (
				let currentDays = intervalDays;
				currentDays <= totalDays;
				currentDays += intervalDays
			) {
				const intervalCount = Math.round(currentDays / intervalDays);
				const label =
					intervalCount * interval.num > 1 && interval.num == 1
						? `${intervalCount * interval.num} ${interval.unit}s`
						: `${intervalCount * interval.num} ${interval.unit}`;
				// console.log("Label here", label);
				if (!seenHeaders.has(label)) {
					headers.push({ label: label });
					seenHeaders.add(label);
				}
			}

			const remainingDays = totalDays % intervalDays;
			if (remainingDays > 0) {
				const remainingLabel = `${total.num} ${total.unit}`;
				if (!seenHeaders.has(remainingLabel)) {
					headers.push({ label: remainingLabel });
					seenHeaders.add(remainingLabel);
				}
			}

			const rows = names.map(name => {
				const row = { Outcomes: name };
				headers.slice(1).forEach(header => {
					row[header.label] = "";
				});
				return row;
			});

			// Adding Baseline at index=1
			headers.splice(1, 0, { label: "Baseline" });
			rows.forEach(row => {
				row["Baseline"] = "";
			});

			const result = {
				headers: headers,
				rows: rows
			};
			this.$tera.project.TrialWizard.timelineTable = result;
			console.log(result);
			return result;
		},
		calculateTimeLine() {
			if (
				this.$tera.project.TrialWizard.trialTimeline != "" &&
				this.$tera.project.TrialWizard.trialTimeline != ""
			) {
				this.calculate();
			}
		},
		compareAndCalculate() {
			const concatednames = [
				...this.$tera.project.TrialWizard.primary.map(item => item.name || ""),
				...this.$tera.project.TrialWizard.secondary.map(item => item.name || "")
				// ...this.$tera.project.adverse.map(item => item.name || "")
			];
			const newNames = concatednames.filter(x => x != "");
			console.log("data", newNames);
			const currentRows =
				this.$tera.project.TrialWizard.timelineTable?.rows || [];
			const currentNames = currentRows.map(row => row.Outcomes);

			const addedNames = newNames.filter(name => !currentNames.includes(name));
			const removedNames = currentNames.filter(
				name => !newNames.includes(name)
			);

			// Update rows: add new rows
			addedNames.forEach(name => {
				const newRow = { Outcomes: name };
				this.$tera.project.TrialWizard.timelineTable.headers
					.slice(1)
					.forEach(header => {
						newRow[header.label] = "";
					});
				this.$tera.project.TrialWizard.timelineTable.rows.push(newRow);
			});

			// Update rows: remove old rows
			this.$tera.project.TrialWizard.timelineTable.rows = this.$tera.project.TrialWizard.timelineTable.rows.filter(
				row => !removedNames.includes(row.Outcomes)
			);

			// Sorting rows are in the same order as new names
			this.$tera.project.TrialWizard.timelineTable.rows.sort(
				(a, b) => newNames.indexOf(a.Outcomes) - newNames.indexOf(b.Outcomes)
			);
			console.log(
				"this.$tera.project.timelineTable",
				JSON.stringify(this.$tera.project.TrialWizard.timelineTable)
			);
		},
		addPreBaseline() {
			const { headers, rows } = this.$tera.project.TrialWizard.timelineTable;
			const hasColumn = headers.some(header => header.label === "Pre-Baseline");
			console.log(rows);

			if (!this.$tera.project.TrialWizard.ispreBaseline && hasColumn) {
				this.$tera.project.TrialWizard.timelineTable.headers = headers.filter(
					header => header.label !== "Pre-Baseline"
				);
				this.$tera.project.TrialWizard.timelineTable.rows.forEach(row => {
					delete row["Pre-Baseline"];
				});
			} else if (this.$tera.project.TrialWizard.ispreBaseline && !hasColumn) {
				this.$tera.project.TrialWizard.timelineTable.headers.splice(1, 0, {
					label: "Pre-Baseline"
				});
				this.$tera.project.TrialWizard.timelineTable.rows.forEach(row => {
					row["Pre-Baseline"] = "";
				});
			}
		}
	}
};
</script>
